module.exports = __webpack_public_path__ + "static/img/yy8.0a751a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy8.png
// module id = whh7
// module chunks = 1